/* eslint-disable @typescript-eslint/no-explicit-any */
import { Divider, Button, AutoCenter, Grid, SafeArea, Space, CapsuleTabs, IndexBar, JumboTabs, NavBar, SideBar, TabBar, Tabs, Avatar, Card, Collapse, ImageViewer, InfiniteScroll, List, Steps, Swiper, Toast, Tag, WaterMark, Footer, ActionSheet, Dialog, DotLoading, Modal, Popover, Popup, ProgressBar, ProgressCircle, PullToRefresh, Result, Skeleton, SwipeAction, Badge, NoticeBar, Cascader, CascaderView, CheckList, Checkbox, Form, Input, TextArea, DatePicker, Selector, Picker, PickerView, Radio, Rate, SearchBar, Slider, Stepper, Switch, Dropdown, FloatingBubble, NumberKeyboard, PasscodeInput, } from 'antd-mobile';
export default {
    Divider,
    Button,
    AutoCenter,
    Grid,
    SafeArea,
    Space,
    CapsuleTabs,
    IndexBar,
    JumboTabs,
    NavBar,
    SideBar,
    TabBar,
    Tabs,
    Avatar,
    Card,
    Collapse,
    ImageViewer,
    InfiniteScroll,
    List,
    Steps,
    Swiper,
    Toast,
    Tag,
    WaterMark,
    Footer,
    ActionSheet,
    Dialog,
    DotLoading,
    Modal,
    Popover,
    Popup,
    ProgressBar,
    ProgressCircle,
    PullToRefresh,
    Result,
    Skeleton,
    SwipeAction,
    Badge,
    NoticeBar,
    Cascader,
    CascaderView,
    CheckList,
    Checkbox,
    Form,
    Input,
    TextArea,
    DatePicker,
    Selector,
    Picker,
    PickerView,
    Radio,
    Rate,
    SearchBar,
    Slider,
    Stepper,
    Switch,
    Dropdown,
    FloatingBubble,
    NumberKeyboard,
    PasscodeInput,
};
//# sourceMappingURL=index.js.map